export default "__VITE_ASSET__CKZK7_I1__"